import { Chips } from '@cian/ui-kit/chips';
import { RadioButtonGroup } from '@cian/ui-kit/radio';
import { Tabs } from '@cian/ui-kit/tabs';

import { OFFERS_DEAL_TYPES, OFFERS_PROPERTY_TYPES } from 'shared/constants/buildingLabels';
import type { IBuildingOfferCategory, TOffersDealType, TOffersPropertyType } from 'shared/types/buildingOffers';

import style from './style.css';

export interface IOffersFiltersProps {
  dealType: TOffersDealType;
  propertyType: TOffersPropertyType | null;
  /** Типы с объявлениями для выбранной сделки — остальные неактивны */
  availablePropertyTypes: TOffersPropertyType[];
  /** Счётчики выбранной категории; null — тип не выбран, вкладок нет */
  category: IBuildingOfferCategory | null;
  isFromRepresentative: boolean;
  onDealTypeChange(dealType: TOffersDealType): void;
  onPropertyTypeChange(propertyType: TOffersPropertyType): void;
  onFromRepresentativeChange(isFromRepresentative: boolean): void;
}

/** Сделка, тип помещения и вкладки «От официального представителя / От агентов» (`serp_filters.tsx` монолита) */
export const OffersFilters = ({
  dealType,
  propertyType,
  availablePropertyTypes,
  category,
  isFromRepresentative,
  onDealTypeChange,
  onPropertyTypeChange,
  onFromRepresentativeChange,
}: IOffersFiltersProps) => (
  <>
    <div className={style['filters']}>
      <RadioButtonGroup
        inline
        size="M"
        options={OFFERS_DEAL_TYPES.map(({ type, label }) => ({ value: type, label }))}
        value={dealType}
        dataTestId="OffersDealType"
        onChange={(_, value) => onDealTypeChange(value as TOffersDealType)}
      />
      {/* Группа скрыта, если для сделки нет ни одного типа */}
      {availablePropertyTypes.length > 0 && (
        <Chips
          inline={true}
          selectType="oneOf"
          size="S"
          options={OFFERS_PROPERTY_TYPES.map(({ type, label }) => ({
            value: type,
            label,
            disabled: !availablePropertyTypes.includes(type),
          }))}
          value={propertyType ? [propertyType] : []}
          dataTestId="OffersPropertyType"
          onChange={([value]) => value && onPropertyTypeChange(value as TOffersPropertyType)}
        />
      )}
    </div>
    {category && (
      <div className={style['tabs']}>
        <Tabs
          size="M"
          rightItem="counter"
          bottomDivider={false}
          activeTabIndex={isFromRepresentative ? 0 : 1}
          items={[
            {
              text: 'От официального представителя',
              counter: category.fromRepresentativeCount || undefined,
              disabled: !category.fromRepresentativeCount,
              dataTestId: 'OffersTabRepresentative',
            },
            {
              text: 'От агентов',
              counter: category.otherCount || undefined,
              disabled: !category.otherCount,
              dataTestId: 'OffersTabOther',
            },
          ]}
          onTabClick={index => onFromRepresentativeChange(index === 0)}
        />
      </div>
    )}
  </>
);
